import {
    SET_NOMBRE_CITAS_SERVICIO,
    SET_APELLIDO_MATERNO_CITAS_SERVICIO,
    SET_APELIIDO_PATERNO_CITAS_SERVICIO,
    SET_ESTADO_CITAS_SERVICIO,
    SET_ID_CONCESIONARIO_CITAS_SERVICIO,
    SET_CONCESIONARIO_CITAS_SERVICIO,
    SET_TELEFONO_CITAS_SERVICIO,
    SET_CORREO_CITAS_SERVICIO,
    SET_FECHA_CITA_CITAS_SERVICIO,
    SET_HORARIO_CITA_CITAS_SERVICIO,
    SET_MODELO_AUTO_CITAS_SERVICIO,
    SET_YEAR_AUTO_CITAS_SERVICIO,
    SET_SERVICIO_CITAS_SERVICIO,
    SET_COMENTARIOS_CITAS_SERVICIO,
    SET_AVISO_PRIVACIDAD_CITAS_SERVICIO,
    SET_DEALER_URLS,
    SET_UUID_CITAS_SERVICIO,
    SET_CITAS_DISPONIBLES_CITAS_SERVICIO,
    SET_LIST_ESTADOS_CITAS_SERVICIO,
    SET_LIST_CONCESIONARIOS_CITAS_SERVICIO,
    SET_LIST_MODELOS_CITAS_SERVICIO,
    SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO,
    RESET_STATE_CITAS_SERVICIO,
    SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO,
    SET_ERROR_CONSULTAR_CITAS_SERVICIO,
    SET_CORREO_CONTACTO_CITAS_SERVICIO,
    SET_DEALER_HORARIOS_OFFLINE
} from "../types";

import {
    getEstados,
    //getConcesionarios,
    getHorarios
} from "../API/CitasServicioRequest";


/**
 * Función para reiniciar el state
 * @returns 
 */
export function reiniciarStateAction() {
    return async (dispatch) => {
        dispatch(reiniciarState());
    }
}
const reiniciarState = () => ({
    type: RESET_STATE_CITAS_SERVICIO
})

/**
 * Función para obtener los estados
 * @returns 
 */
export function setListEstadosAction() {
    return async (dispatch) => {
        getEstados()
            .then((responseEstados) => {
                dispatch(setListEstados(responseEstados.data));
            })
    }
}
const setListEstados = (listEstados) => ({
    type: SET_LIST_ESTADOS_CITAS_SERVICIO,
    payload: listEstados,
})

/**
 * Función para obtener las concesionarias
 * @returns 
 */
export function setListConcesionariosAction(concesionarios) {
    return async (dispatch) => {
        dispatch(setListConcesionarios(concesionarios));
    }
}
const setListConcesionarios = (listConcesionarios) => ({
    type: SET_LIST_CONCESIONARIOS_CITAS_SERVICIO,
    payload: listConcesionarios,
})

/**
 * 
 * @param {*} listModelos 
 * @returns 
 */
export function setListModelosAction(listModelos) {
    return (dispatch) => {
        dispatch(setListModelos(listModelos));
    };
}
const setListModelos = (listModelos) => ({
    type: SET_LIST_MODELOS_CITAS_SERVICIO,
    payload: listModelos,
});


/**
 * 
 * @param {*} listFechasHorarios 
 * @returns 
 */
export function setListFechasHorariosAction(uuid, fechaInicial, fechaFinal, tipoServicio, idConcesionario, horariosDealerOffline) {
    return async (dispatch) => {
        dispatch(setBuscaFechasLoading(true));
        dispatch(setErrorConsultarCitas(false));

        getHorarios(uuid, fechaInicial, fechaFinal, tipoServicio, idConcesionario)
            .then((responseListFechasHorarios) => {
                dispatch(setBuscaFechasLoading(false));
                dispatch(setListFechasHorarios(responseListFechasHorarios.data.data));

                if (responseListFechasHorarios.data.data === null
                    || responseListFechasHorarios.data.data.length === 0
                    || (responseListFechasHorarios.data.data.hasOwnProperty('message') && responseListFechasHorarios.data.data.message === "Endpoint request time out")
                    || (responseListFechasHorarios.data.data.hasOwnProperty('errorCode') && responseListFechasHorarios.data.data.hasOwnProperty('title'))
                    || (responseListFechasHorarios.data.data.horariosAtencion 
                        && Object.keys(responseListFechasHorarios.data.data.horariosAtencion[fechaInicial]).length === 0)) {
                        getHorariosOffline(dispatch, fechaInicial, horariosDealerOffline);
                }
            }).catch((error) => {
                console.log(error);
                dispatch(setBuscaFechasLoading(false));
                getHorariosOffline(dispatch, fechaInicial, horariosDealerOffline);
            })
    }
}
const setListFechasHorarios = (listFechasHorarios) => ({
    type: SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO,
    payload: listFechasHorarios,
});

const setBuscaFechasLoading = (loadingBuscarFechas) => ({
    type: SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO,
    payload: loadingBuscarFechas,
});

const setErrorConsultarCitas = (setErrorConsultar) => ({
    type: SET_ERROR_CONSULTAR_CITAS_SERVICIO,
    payload: setErrorConsultar,
});


/**
 * 
 * @param {*} inNombre 
 * @returns 
 */
export function setNombreAction(inNombre) {
    return (dispatch) => {
        dispatch(setNombre(inNombre));
    };
}
const setNombre = (inNombre) => ({
    type: SET_NOMBRE_CITAS_SERVICIO,
    payload: inNombre,
});
/**
 * 
 * @param {*} inApellidoPaterno 
 * @returns 
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
    return (dispatch) => {
        dispatch(setApellidoPaterno(inApellidoPaterno));
    };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
    type: SET_APELIIDO_PATERNO_CITAS_SERVICIO,
    payload: inApellidoPaterno,
});
/**
 * 
 * @param {*} inApellidoMaterno 
 * @returns 
 */
export function setApellidoMaternoAction(inApellidoMaterno) {
    return (dispatch) => {
        dispatch(setApellidoMaterno(inApellidoMaterno));
    };
}
const setApellidoMaterno = (inApellidoMaterno) => ({
    type: SET_APELLIDO_MATERNO_CITAS_SERVICIO,
    payload: inApellidoMaterno,
});
/**
 * 
 * @param {*} inEstado 
 * @returns 
 */
export function setEstadoAction(inEstado) {
    return (dispatch) => {
        dispatch(setEstado(inEstado));
    };
}
const setEstado = (inEstado) => ({
    type: SET_ESTADO_CITAS_SERVICIO,
    payload: inEstado,
});
/**
 * 
 * @param {*} inIdConcesionario 
 * @returns 
 */
export function setIdConcesionarioAction(inIdConcesionario) {
    return (dispatch) => {
        dispatch(setIdConcesionario(inIdConcesionario.length === 3 ? "0" + inIdConcesionario : inIdConcesionario));
    };
}
const setIdConcesionario = (inIdConcesionario) => ({
    type: SET_ID_CONCESIONARIO_CITAS_SERVICIO,
    payload: inIdConcesionario,
});
/**
 * 
 * @param {*} inConcesionario 
 * @returns 
 */
export function setConcesionarioAction(inConcesionario) {
    return (dispatch) => {
        dispatch(setConcesionario(inConcesionario));
    };
}
const setConcesionario = (inConcesionario) => ({
    type: SET_CONCESIONARIO_CITAS_SERVICIO,
    payload: inConcesionario,
});
/**
 * 
 * @param {*} inTelefono 
 * @returns 
 */
export function setTelefonoAction(inTelefono) {
    return (dispatch) => {
        dispatch(setTelefono(inTelefono));
    };
}
const setTelefono = (inTelefono) => ({
    type: SET_TELEFONO_CITAS_SERVICIO,
    payload: inTelefono,
});
/**
 * 
 * @param {*} inCorreo 
 * @returns 
 */
export function setCorreoAction(inCorreo) {
    return (dispatch) => {
        dispatch(setCorreo(inCorreo));
    };
}
const setCorreo = (inCorreo) => ({
    type: SET_CORREO_CITAS_SERVICIO,
    payload: inCorreo,
});
/**
 * 
 * @param {*} inFechaCita 
 * @returns 
 */
export function setFechaCitaAction(inFechaCita) {
    return (dispatch) => {
        dispatch(setFechaCita(inFechaCita));
    };
}
const setFechaCita = (inFechaCita) => ({
    type: SET_FECHA_CITA_CITAS_SERVICIO,
    payload: inFechaCita,
});
/**
 * 
 * @param {*} inHorario 
 * @returns 
 */
export function setHorarioAction(inHorario) {
    return (dispatch) => {
        dispatch(setHorario(inHorario));
    };
}
const setHorario = (inHorario) => ({
    type: SET_HORARIO_CITA_CITAS_SERVICIO,
    payload: inHorario,
});
/**
 * 
 * @param {*} inModeloAuto 
 * @returns 
 */
export function setModeloAutoAction(inModeloAuto) {
    return (dispatch) => {
        dispatch(setModeloAuto(inModeloAuto));
    };
}
const setModeloAuto = (inModeloAuto) => ({
    type: SET_MODELO_AUTO_CITAS_SERVICIO,
    payload: inModeloAuto,
});
/**
 * 
 * @param {*} inYearAuto 
 * @returns 
 */
export function setYearAutoAction(inYearAuto) {
    return (dispatch) => {
        dispatch(setYearAuto(inYearAuto));
    };
}
const setYearAuto = (inYearAuto) => ({
    type: SET_YEAR_AUTO_CITAS_SERVICIO,
    payload: inYearAuto,
});
/**
 * 
 * @param {*} inServicio 
 * @returns 
 */
export function setServicioAction(inServicio) {
    return (dispatch) => {
        dispatch(setServicio(inServicio));
    };
}
const setServicio = (inServicio) => ({
    type: SET_SERVICIO_CITAS_SERVICIO,
    payload: inServicio,
});
/**
 * 
 * @param {*} inComentarios 
 * @returns 
 */
export function setComentariosAction(inComentarios) {
    return (dispatch) => {
        dispatch(setComentarios(inComentarios));
    };
}
const setComentarios = (inComentarios) => ({
    type: SET_COMENTARIOS_CITAS_SERVICIO,
    payload: inComentarios,
});
/**
 * 
 * @param {*} inAvisoPrivacidad 
 * @returns 
 */
export function setAvisoPrivacidadAction(inAvisoPrivacidad) {
    return (dispatch) => {
        dispatch(setAvisoPrivacidad(inAvisoPrivacidad));
    };
}
const setAvisoPrivacidad = (inAvisoPrivacidad) => ({
    type: SET_AVISO_PRIVACIDAD_CITAS_SERVICIO,
    payload: inAvisoPrivacidad,
});
/**
 * 
 * @param {*} inTerminos 
 * @returns 
 */
export function setDealersUrlsAction(inDealersUrls) {
    return (dispatch) => {
        dispatch(setDealersUrls(inDealersUrls));
    };
}
const setDealersUrls = (inDealersUrls) => ({
    type: SET_DEALER_URLS,
    payload: inDealersUrls,
});
/**
 * 
 * @param {*} inUuid 
 * @returns 
 */
export function setUuidAction(inUuid) {
    return (dispatch) => {
        dispatch(setUuid(inUuid));
    };
}
const setUuid = (inUuid) => ({
    type: SET_UUID_CITAS_SERVICIO,
    payload: inUuid,
});
/**
 * 
 * @param {*} inCitasDisponibles 
 * @returns 
 */
export function setCitasDisponiblesAction(inCitasDisponibles) {
    return (dispatch) => {
        dispatch(setCitasDisponibles(inCitasDisponibles));
    };
}
const setCitasDisponibles = (inCitasDisponibles) => ({
    type: SET_CITAS_DISPONIBLES_CITAS_SERVICIO,
    payload: inCitasDisponibles,
});
/**
 * 
 * @param {*} correoContacto 
 * @returns 
 */
export function setCorreoContactoAction(correoContacto) {
    return (dispatch) => {
        dispatch(setCorreoContacto(correoContacto));
    };
}
const setCorreoContacto = (correoContacto) => ({
    type: SET_CORREO_CONTACTO_CITAS_SERVICIO,
    payload: correoContacto,
});
/**
 * 
 * @param {*} horariosOffline 
 * @returns 
 */
export function setHorariosDealerOfflineAction(horariosOffline) {
    return (dispatch) => {
        dispatch(setHorariosDealerOffline(horariosOffline));
    };
}
const setHorariosDealerOffline = (horariosOffline) => ({
    type: SET_DEALER_HORARIOS_OFFLINE,
    payload: horariosOffline,
});

const getHorariosOffline = (dispatch, fechaInicial, horariosDealerOffline) => {
    dispatch(setErrorConsultarCitas(true));

    const numberDay = new Date(fechaInicial).getDay();
    const horarioDiaSelected = horariosDealerOffline[numberDay].split("-");

    let horarioInicial = new Date()
    horarioInicial.setHours(parseInt(horarioDiaSelected[0].split(":")[0]))
    horarioInicial.setMinutes(parseInt(horarioDiaSelected[0].split(":")[1]))
    horarioInicial.setSeconds(0)

    let horarioFinal = new Date()
    horarioFinal.setHours(parseInt(horarioDiaSelected[1].split(":")[0]))
    horarioFinal.setMinutes(parseInt(horarioDiaSelected[1].split(":")[1]))
    horarioFinal.setSeconds(0)

    let serieHorariosOffline = []

    while (horarioInicial <= horarioFinal) {
        serieHorariosOffline.push(("0" + horarioInicial.getHours()).slice(-2) + ":" + ("0" + horarioInicial.getMinutes()).slice(-2));
        horarioInicial.setHours(horarioInicial.getHours() + 1);
    }

    // eslint-disable-next-line
    const res = serieHorariosOffline.reduce((acc, curr) => (acc[curr] = '', acc), {});

    let horariosOffline = {
        horariosAtencion: {
            [fechaInicial]: res
        }
    }

    dispatch(setListFechasHorarios(horariosOffline));
}